import lb from '@/lib/loopback';


export function findTiposuporte(settings = {}) {
  return lb
    .find('/Tiposuportes/', settings);
}

export default {
  findTiposuporte,
};
